import {createStore, applyMiddleware} from 'redux';
import {combineReducers} from 'redux';
import thunk from 'redux-thunk';
import {createLogger} from 'redux-logger';
import {
  reducer as idleReducer,
  createMiddleware as createPromise,
} from 'redux-promises';

import PartListReducer from './CarDamageActions';

export default () => {

  let middlewares = [thunk, createPromise()];

  if (process.env.NODE_ENV == 'development') {
    middlewares.push(createLogger());
  }

  return createStore(
      PartListReducer,
      applyMiddleware(...middlewares),
  );
}



// WEBPACK FOOTER //
// ./src/view/workdoc/CarDamageStore.js